import { createApp } from "./setup"

createApp().mount("#app")